import {
  CircularProgress,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import useAxiosPrivate from 'hooks/useAxiosPrivate';
import { memo, useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { useSearchParams } from 'react-router-dom';
import ObjectFilter from './ObjectFilter';

const types = [
  {
    name: 'Obyekt',
    id: 1,
  },
  {
    name: 'Blok',
    id: 2,
  },
];

const ReasonTypeFilter = ({ size = undefined, className, allowClear }) => {
  const axiosPrivate = useAxiosPrivate();
  const [hasError, setHasError] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  const {
    data: blocks,
    isLoading,
    isFetching,
  } = useQuery({
    queryKey: ['/dictionary/blocks/{object_id}', searchParams.get('object_id')],
    queryFn: async function () {
      const response = await axiosPrivate.get(
        `/dictionary/blocks/${searchParams.get('object_id')}`
      );
      return response.data.data;
    },

    enabled: !hasError && !!searchParams.get('object_id'),
    onError: (error) => {
      setHasError(true);
    },
    retry: false,
  });

  const handleChange = (event, query) => {
    const {
      target: { value },
    } = event;
    searchParams.set(query, value);
    setSearchParams(searchParams);
  };

  const handleClearSelectBox = (query) => {
    searchParams.delete(query);
    setSearchParams(searchParams);
  };

  useEffect(() => {
    const type = searchParams.get('type');
    const object_id = searchParams.get('object_id');
    const block_id = searchParams.get('block_id');
    if (type == 1) {
      if (object_id) {
        searchParams.set('reason_id', object_id);
      } else searchParams.delete('reason_id');
    } else if (type == 2) {
      if (block_id) {
        searchParams.set('reason_id', block_id);
      } else searchParams.delete('reason_id');
    } else {
      searchParams.delete('reason_id');
    }
    setSearchParams(searchParams);
  }, [searchParams, setSearchParams]);

  return (
    <>
      <FormControl fullWidth color='formColor'>
        <InputLabel id='single-block-filter-label'>Turi</InputLabel>
        <Select
          className={className}
          labelId='single-block-filter-label'
          id='single-block-filter-chip'
          value={searchParams.get('type')}
          onChange={(e) => handleChange(e, 'type')}
          color='formColor'
          variant='outlined'
          size={size}
          MenuProps={{
            id: 'single-block-filter-select-menu',
            PaperProps: {
              style: {
                maxHeight: 300,
              },
            },
            disableScrollLock: true,
          }}
          endAdornment={
            <InputAdornment position='end' className='custom-endAdornment'>
              {allowClear && searchParams.get('type') && (
                <IconButton
                  onClick={() => handleClearSelectBox('type')}
                  variant='onlyIcon'
                  className='select-box-end-adornment-button'
                >
                  <i className='bi bi-x end-adornment-close-button' />
                </IconButton>
              )}
            </InputAdornment>
          }
        >
          {types.map((item, index) => (
            <MenuItem value={item.id} key={`block-${index + 1}`}>
              {item.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <ObjectFilter allowClear={allowClear} query='object_id' />
      {searchParams.get('type') == 2 && (
        <FormControl fullWidth color='formColor'>
          <InputLabel id='single-block-filter-label'>'Blok</InputLabel>
          <Select
            className={className}
            labelId='single-block-filter-label'
            id='single-block-filter-chip'
            value={searchParams.get('block_id')}
            onChange={(e) => handleChange(e, 'block_id')}
            color='formColor'
            variant='outlined'
            size={size}
            MenuProps={{
              id: 'single-block-filter-select-menu',
              PaperProps: {
                style: {
                  maxHeight: 300,
                },
              },
              disableScrollLock: true,
            }}
            endAdornment={
              <InputAdornment position='end' className='custom-endAdornment'>
                {allowClear && searchParams.get('block_id') && (
                  <IconButton
                    onClick={() => handleClearSelectBox('block_id')}
                    variant='onlyIcon'
                    className='select-box-end-adornment-button'
                  >
                    <i className='bi bi-x end-adornment-close-button' />
                  </IconButton>
                )}
              </InputAdornment>
            }
          >
            {isLoading || isFetching ? (
              <div className='circular-progress-box'>
                <CircularProgress size={25} />
              </div>
            ) : blocks && blocks.length > 0 ? (
              blocks.map((item, index) => (
                <MenuItem value={item.id} key={`block-${index + 1}`}>
                  {item.name}
                </MenuItem>
              ))
            ) : (
              <div>
                <span className='no-data-found-wrapper select-box'>
                  <i className='bi bi-exclamation-octagon text-lg mr-1' />{' '}
                  Ma'lumot topilmadi!
                </span>
              </div>
            )}
          </Select>
        </FormControl>
      )}
    </>
  );
};

export default memo(ReasonTypeFilter);
